var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertifie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "50px",
    viewBox: "0 0 44 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Label de confiance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Qui-sommes-nous-?",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Nos_valeurs",
    transform: "translate(-687.000000, -1074.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(51.000000, 1032.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(481.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(119.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/aperture",
    transform: "translate(36.425000, 33.444444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1111111,0 C37.8777778,0 41.4666667,4.36666667 42.1222222,6.96666667 C42.188699,7.23191184 42.2222847,7.50432915 42.2222222,7.77777778 L42.2222222,22.5555556 C42.2045908,31.7687813 37.2291468,40.2593 29.2,44.7777778 L22.7444444,48.4111111 C21.730182,48.9812336 20.4920402,48.9812336 19.4777778,48.4111111 L13.0222222,44.7777778 C4.99307547,40.2593 0.0176314704,31.7687813 0,22.5555556 L0.000552946046,7.72078159 C0.0162509448,6.90090703 0.38968254,4.42169312 4.06666667,2.57777778 C7.47777778,0.866666667 13.2111111,0 21.1111111,0 Z M21.1111111,3.33333333 C3.86666667,3.33333333 3.34933333,7.51511111 3.33381333,7.76601778 L3.33333333,22.5555556 C3.33286131,30.5821407 7.66085864,37.9851822 14.6555556,41.9222222 L21.1111111,45.5555556 L27.5666667,41.8888889 C34.5613636,37.9518489 38.8893609,30.5488073 38.8888889,22.5222222 L38.8885411,7.77645333 L38.87875,7.74555556 C38.7388889,7.34444444 36.9444444,3.33333333 21.1111111,3.33333333 Z M31.0444444,15.4888889 L20,26.5333333 L13.4,19.9333333 C12.7433117,19.3214248 11.7199784,19.3394803 11.0852849,19.9741738 C10.4505914,20.6088673 10.4325359,21.6322005 11.0444444,22.2888889 L18.8222222,30.0666667 C19.4729279,30.7165631 20.5270721,30.7165631 21.1777778,30.0666667 L33.4,17.8444444 C34.0119086,17.1877561 33.9938531,16.1644228 33.3591596,15.5297293 C32.724466,14.8950358 31.7011328,14.8769803 31.0444444,15.4888889 L31.0444444,15.4888889 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifie);
export default __webpack_public_path__ + "static/media/Certifie.0fa23c4f308a6db021581b9a6a9bff74.svg";
export { ForwardRef as ReactComponent };